import React from 'react';
import { Clock, Award } from 'lucide-react';

interface SessionProgressProps {
  currentTime: number;
  totalTime: number;
  attentionScore: number;
}

export default function SessionProgress({ currentTime, totalTime, attentionScore }: SessionProgressProps) {
  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const progressPercentage = (currentTime / totalTime) * 100;

  return (
    <div className="flex items-center space-x-6">
      {/* Time Display */}
      <div className="flex items-center space-x-2 text-sm">
        <Clock className="w-4 h-4 text-gray-400" />
        <span className="text-white">
          {formatTime(currentTime)} / {formatTime(totalTime)}
        </span>
      </div>

      {/* Progress Bar */}
      <div className="w-48">
        <div className="flex justify-between text-xs text-gray-400 mb-1">
          <span>Progress</span>
          <span>{Math.round(progressPercentage)}%</span>
        </div>
        <div className="w-full bg-gray-700 rounded-full h-2">
          <div 
            className="bg-blue-600 h-2 rounded-full transition-all duration-1000"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      {/* Attention Score */}
      <div className="flex items-center space-x-2 text-sm">
        <Award className="w-4 h-4 text-yellow-400" />
        <span className="text-white">
          Attention: {attentionScore}%
        </span>
      </div>
    </div>
  );
}